import { FC, ReactNode } from "react";
import ModuleHeaderSkeleton from "./components/ModuleHeaderSkeleton";
import { SkeletonContainer, SkeletonContentWrapper } from "./styled";

interface ModuleSkeletonProps {
  children: ReactNode;
  contentGap?: number;
  containerGap?: number;
  alignItems?: "center" | "flex-start" | "flex-end";
}

const ModuleSkeleton: FC<ModuleSkeletonProps> = ({
  children,
  contentGap = 16,
  containerGap = 16,
  alignItems = "center",
}) => {
  return (
    <SkeletonContainer $gap={containerGap} $alignItems={alignItems}>
      <ModuleHeaderSkeleton />
      <SkeletonContentWrapper $gap={contentGap}>
        {children}
      </SkeletonContentWrapper>
    </SkeletonContainer>
  );
};

export default ModuleSkeleton;
